var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Modal } from '../../Components/Modals/Modal';
import styles from './zeroid_styles.module.css';
import { CaptionLogo } from '../../Components/Footer/Caption/CaptionLogo';
import { FeatureFlag, useFeatureFlag } from '../../Contexts/FeatureFlagContext';
import { useUpdateTimer } from '../../hooks/useUpdateTimer';
import { useOrder } from '../../Contexts/ApplicationContext';
import { currentOrderCreateZeroID } from '../../../Services/zeroid';
import { isKYCSubmittedWithCurrentOrder } from '../KYC/utils';
import { useTheme } from 'styled-components';
var BannerModal = function () {
    var _a = useState(isKYCSubmittedWithCurrentOrder()), isOpen = _a[0], setIsOpen = _a[1];
    var userInfo = useOrder().userInfo;
    var whiteLabel = useFeatureFlag(FeatureFlag.ENABLE_WHITELABEL);
    var _b = useUpdateTimer(3, function (timer) { return "You will pass on details after ".concat(timer, " seconds..."); }), process = _b.process, counterText = _b.text;
    var type = useTheme().colors.type;
    useEffect(function () {
        if (!process) {
            setIsOpen(false);
        }
    }, [process]);
    var backgroundImage = "url(\"../../../../public/asset/zero_id_success/".concat(type, "/background.png\")");
    return (_jsx(Modal, __assign({ style: { backgroundImage: backgroundImage }, isOpen: isOpen }, { children: _jsxs("div", __assign({ className: styles.wrapper }, { children: [_jsxs("div", __assign({ className: styles.description }, { children: ["We sent you an email to ", _jsx("span", { children: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email }), " with instruction how to use your ZeroID."] })), _jsx("div", __assign({ className: styles.counter }, { children: counterText })), whiteLabel ? (_jsxs("div", __assign({ className: styles.capture }, { children: [_jsx("span", { children: "Powered by" }), _jsx(CaptionLogo, {})] }))) : null] })) })));
};
export var ZeroIdBanner = function () {
    var open = currentOrderCreateZeroID();
    return _jsx(_Fragment, { children: open && _jsx(BannerModal, {}) });
};
